import React from 'react';
import { Link } from 'react-router-dom';
import TextareaAutosize from 'react-textarea-autosize';
import { Button, FormGroup, Input, Col, Row, Container, Label } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import utils from '../../resources/utils';
import DataRow from '../DataRow';
import Segment from '../Segment';
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname

const SCREEN_WITH_CONTENTS = ['post', 'tag', 'url_open', 'community', 'profile'];
export default class ActionEdit extends React.Component {
    constructor(props) {
        super(props);
        let defaultNotification = {
            title: '',
            content: '',
        };
        if (this.props.notification) {
            defaultNotification = this.props.notification;
        }
        this.state = {
            notification: defaultNotification,
            maxTitleLength: 30,
        };
    }
    componentWillMount() {}
    componentDidMount() {}
    saveNotification() {
        const { notification } = this.state;
        const { onSave } = this.props;
        if (onSave) {
            onSave(notification);
        }
    }
    updateAttr(attribute, value) {
        const { notification } = this.state;
        notification[attribute] = value;

        const STATIC_SCREEN = ['summary_open', 'week_summary_open', 'month_summary_open', 'media_open', 'reward_store'];

        // Set notification external payload
        if (notification.screen) {
            let external_payload = {}
            if (STATIC_SCREEN.indexOf(notification.screen) < 0) {
                external_payload.notification_type = `${notification.screen}_${notification.content_id}`;
            } else {
                notification.content_id = null;
                external_payload.notification_type = `${notification.screen}`;
            }
            notification.data = external_payload;
        }
        
        this.setState({ notification }, this.saveNotification);
    }
    fetchThreadInfo(threadUrl) {
        let threadId = threadUrl.split('.').slice(-1)[0];
        threadId = threadId.replace(/\D/g,'');
        api.fetchAPI({
            method: 'get',
            uri: `thread/${threadId}`,
            success: (response) => {
                if (response.status == 'ok') {
                    const thread = response.thread;
                    this.updateAttr('content_id', thread.first_post.post_id);
                    if (thread.thread_image) {
                        if (thread.thread_image.link) {
                            this.updateAttr('image_url', thread.thread_image.link);
                        }
                    }
                } else {
                    alert(response.message);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    render() {
        const {
            notification,
            maxTitleLength,
        } = this.state;
        if (!notification) return null;
        return (
            <div className="notification-edit-container">
                <h4>Notification content</h4>
                <p className="notification_userguide">
                    Các personalization được hỗ trợ: {`{{ user_name | default: 'bạn' }}`}
                </p>
                <FormGroup>
                    <Label>
                        <span>Title</span>
                        {notification && notification.title.length > maxTitleLength &&
                            <span className="notification_title_error">
                                You exceeded the maximum 30 of text characters!!
                            </span>
                        }
                    </Label>
                    <Input
                        type="text"
                        value={notification.title}
                        placeholder="Title of notification"
                        onChange={(e) => this.updateAttr('title', e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>Content</Label>
                    <p className="notification_userguide">
                        Parameters được hỗ trợ: Bất kì parameters nào có trong query.
                    </p>
                    <TextareaAutosize
                        className="form-control"
                        type="textarea"
                        value={notification.content}
                        placeholder="Body of the notification"
                        onChange={(e) => this.updateAttr('content', e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>Image URL</Label>
                    <Input
                        className="form-control"
                        type="text"
                        value={notification.image_url}
                        placeholder="Link of a photo"
                        onChange={(e) => this.updateAttr('image_url', e.target.value)}
                    />
                    {notification.image_url &&
                        <div className="notification-image-container">
                            <img src={notification.image_url} className="notification-image" />
                        </div>
                    }
                </FormGroup>
                <FormGroup>
                    <Label>Small Image URL</Label>
                    <Input
                        className="form-control"
                        type="text"
                        value={notification.small_image_url}
                        placeholder="Link of a photo"
                        onChange={(e) => this.updateAttr('small_image_url', e.target.value)}
                    />
                    {notification.small_image_url &&
                        <div className="notification-image-container">
                            <img src={notification.small_image_url} className="notification-image" />
                        </div>
                    }
                </FormGroup>
                <FormGroup>
                    <Label>Go to screen</Label>
                    <p className="notification_userguide">
                        Nếu chọn Tag thì trong query phải include thêm tag_url
                    </p>
                    <Input
                        type="select"
                        value={notification.screen}
                        onChange={(e) => this.updateAttr('screen', e.target.value)}
                    >
                        <option value="">--- Select a screen ---</option>
                        <option value="post">Thread</option>
                        <option value="summary_open">24h News Summary</option>
                        <option value="week_summary_open">Weekly News Summary</option>
                        <option value="month_summary_open">Monthly News Summary</option>
                        <option value="url_open">WebView</option>
                        <option value="tag">Tag</option>
                        <option value="community">Community</option>
                        <option value="profile">Profile</option>
                        <option value="media_open">Media</option>
                        <option value="reward_store">Reward</option>
                    </Input>
                </FormGroup>
                {notification.screen == 'post' &&
                    <FormGroup>
                        <Label>Dán URL thread vào đây để lấy post_id</Label>
                        <Input
                            type="text"
                            placeholder="URL của thread"
                            onChange={(e) => this.fetchThreadInfo(e.target.value)}
                        />
                    </FormGroup>
                }
                {notification.screen && SCREEN_WITH_CONTENTS.includes(notification.screen) &&
                    <FormGroup>
                        <Label>Go to Content ID</Label>
                        <p className="notification_userguide">
                            Parameters được hỗ trợ: {`{{ content_id }}`} và content_id phải có trong query.
                        </p>
                        <Input
                            type="text"
                            value={notification.content_id}
                            placeholder="Post ID, Tag ID, Community tag text..."
                            onChange={(e) => this.updateAttr('content_id', e.target.value)}
                        />
                    </FormGroup>
                }
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/NotificationEdit/index.js